import type { MentionSection } from "./metricPromptMentionTokens"

const AGENT_ATTRIBUTE_OPTIONS = [
  { key: "display_name", description: "Agent display name" },
  { key: "phone_number", description: "Agent phone number" },
  { key: "description", description: "Agent description" },
  { key: "prompt", description: "Agent prompt" },
]

// Example keys mirror the backend template-variable schema
// (src/modules/metrics/template_variables/schema.py -> customer_metadata.example_keys).
// Shown only as a hint until the org has uploaded conversations whose
// customer_metadata supplies real keys; users can still type any custom key.
export const CUSTOMER_METADATA_EXAMPLE_KEYS = [
  { key: "call_id", description: "example" },
  { key: "department", description: "example" },
  { key: "region", description: "example" },
  { key: "customer_tier", description: "example" },
]

export function buildQuestionTextareaMentionSections({
  testSetMetadataKeys,
  customerMetadataKeys,
}: {
  testSetMetadataKeys: string[]
  customerMetadataKeys?: string[]
}): MentionSection[] {
  const sections: MentionSection[] = [
    {
      id: "agent",
      label: "Agent attributes",
      tokenPrefix: "agent",
      options: AGENT_ATTRIBUTE_OPTIONS,
    },
  ]

  if (testSetMetadataKeys.length > 0) {
    sections.push({
      id: "test_case",
      label: "Test case attributes",
      tokenPrefix: "test_case",
      options: testSetMetadataKeys.map((key) => ({ key })),
    })
  }

  sections.push({
    id: "customer_metadata",
    label: "Customer metadata (upload-time)",
    tokenPrefix: "customer_metadata",
    options:
      customerMetadataKeys && customerMetadataKeys.length > 0
        ? customerMetadataKeys.map((key) => ({ key }))
        : CUSTOMER_METADATA_EXAMPLE_KEYS,
  })

  return sections
}
